import { makeStyles } from '@mui/styles';

const getCellSize = (percentage: number) => {
  return `calc(100% * ${percentage / 100})`;
};

export const useTableRowStyles = makeStyles((theme) => ({
  cell: {
    display: 'flex',
    flex: '0 0 auto',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: '16px 12px',
  },

  dealPriceCell: {
    paddingLeft: '16px',
    minWidth: '120px',
    width: getCellSize(12),

    [theme.breakpoints.up('xl')]: {
      width: getCellSize(16),
    },
  },

  percentCell: {
    minWidth: '80px',
    width: '80px',
  },

  riskCell: {
    minWidth: '80px',
    width: getCellSize(6),
    paddingLeft: '16px',

    [theme.breakpoints.up('xl')]: {
      width: getCellSize(8),
    },
  },

  productTypeCell: {
    minWidth: '90px',
    width: getCellSize(6),

    [theme.breakpoints.up('xl')]: {
      width: getCellSize(12),
    },
  },

  nominalValueCell: {
    minWidth: '140px',
    width: getCellSize(12),

    [theme.breakpoints.up('xl')]: {
      width: getCellSize(16),
    },
  },

  timeLeftCell: {
    minWidth: '120px',
    width: getCellSize(11),

    [theme.breakpoints.up('xl')]: {
      width: getCellSize(15),
    },
  },

  irrCell: {
    minWidth: '100px',
    width: getCellSize(10),

    [theme.breakpoints.up('xl')]: {
      width: getCellSize(17),
    },
  },

  expirationCell: {
    minWidth: '120px',
    width: getCellSize(10),

    [theme.breakpoints.up('xl')]: {
      width: getCellSize(12),
    },
  },

  inputCell: {
    maxWidth: 'calc(50px + 32px)',
    minWidth: 'calc(50px + 32px)',
    width: 'calc(50px + 32px)',
    minHeight: 'calc(34px + 32px)',
    flexShrink: 0,
    paddingLeft: '16px',
    paddingRight: '16px',
  },
}));
